<div style="    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding: 30% 45%;
    background: #4747478a;">
    <mat-spinner></mat-spinner>

</div>